import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const products = [
  { 
    id: 'almcode', 
    name: 'ARUMCODE', 
    description: '図面データの解析から加工プロセスの生成、さらには見積作成まで、製造業の核心的な業務をサポートし、 生産性の飛躍的な向上と人材不足の解消を同時に実現します。',
    image: '/images/products/ARUMCODE1.png',
    bgColor: 'bg-blue-50',
    isVisible: false
  },
  { 
    id: 'harucool', 
    name: 'はるクール', 
    description: 'はるクールは、最先端の技術を駆使して開発された革新的な遮熱材です。最大97%の熱を反射し、夏の暑さと冬の寒さから建物を守ります。',
    image: '/images/products/maxresdefault.jpg',
    bgColor: 'bg-green-50',
    isVisible: true
  },
];

const ProductFeaturePage = () => {
  const visibleProducts = products.filter(product => product.isVisible);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-gradient-to-b from-blue-50 to-white pt-16 md:pt-24"
    >
      <div className="container mx-auto px-4 py-8 md:py-16">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 md:mb-12 text-center text-blue-900">製品特集</h1>
        <div className="space-y-6 md:space-y-8">
          {visibleProducts.map((product, index) => (
            <motion.div
              key={product.id}
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              className={`${product.bgColor} shadow-lg md:shadow-2xl rounded-lg overflow-hidden hover:shadow-xl md:hover:shadow-3xl transition-all duration-300`}
            >
              <div className="flex flex-col md:flex-row md:h-64">
                <div className="md:w-1/3 h-48 md:h-full relative">
                  <img
                    src={product.image}
                    alt={`${product.name}の画像`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="md:w-2/3 p-4 md:p-6 flex flex-col justify-between">
                  <div>
                    <Link
                      to={`/products/${product.id}`}
                      className="block mt-2 text-xl md:text-2xl leading-tight font-bold text-blue-900 hover:underline"
                    >
                      {product.name}
                    </Link>
                    <p className="mt-2 md:mt-4 text-sm md:text-base text-gray-600">{product.description}</p>
                  </div>
                  <div className="mt-4 md:mt-6">
                    <Link
                      to={`/products/${product.id}`}
                      className="inline-block px-4 py-2 bg-blue-500 text-white font-semibold rounded-full hover:bg-blue-600 transition-colors duration-300 shadow-md hover:shadow-lg text-sm md:text-base"
                    >
                      詳細を見る
                    </Link>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="py-12 md:py-16 bg-blue-900 text-white mt-12 md:mt-16">
        <div className="container mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 md:mb-8 text-center">製品に関するお問い合わせ</h2>
          <p className="text-center mb-6 md:mb-8 text-base md:text-lg">
            製品についてのご質問や詳細情報が必要な場合は、お気軽にお問い合わせください。
          </p>
          <div className="text-center">
            <Link
              to="/contact"
              className="inline-block px-6 md:px-8 py-3 md:py-4 bg-white text-blue-900 font-bold rounded-full hover:bg-blue-100 transition-colors duration-300 shadow-md hover:shadow-lg text-base md:text-lg"
            >
              お問い合わせはこちら
            </Link>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductFeaturePage;